<template lang="pug">
a.link.gap-2.align-items-center(
  v-bind="$attrs"
  :href="`tel:${props.phone || props.text}`"
  rel="noopener noreferrer nofollow"
  target="_blank"
  @click="handleClick"
  :class="[hoverOverrideClass, $attrs.class]"
)
  slot(v-if='$slots.prevLabel' name='prevLabel' :text="props.text")
    | Phone:&nbsp;{{ props.text }}
  template(v-else)
    | {{ props.text }}
  slot
</template>

<script setup lang="ts">
import { useGtm } from '@gtm-support/vue-gtm';
import { type PhoneDestinationProps } from './PhoneDestination.types';
import { phoneDestinationDefaults } from './PhoneDestination.defaults';
import useSkinDestinationHoverOverride from '../../../../../composables/useSkinDestinationHoverOverride';

const props = withDefaults(
  defineProps<PhoneDestinationProps>(),
  phoneDestinationDefaults as any,
) as unknown as PhoneDestinationProps;

const { hoverOverrideValue, hoverOverrideClass } =
  useSkinDestinationHoverOverride(props as any);

const gtm = useGtm();

function handleClick(event: Event) {
  if (props.isDisabled) {
    event.preventDefault();
    return;
  }

  if (gtm) {
    gtm.trackEvent({
      event: 'phone_link',
      value: parseInt('1', 10),
      currency: 'EUR',
      event_category: 'leads',
      event_label: `User Contact by Phone`,
    });
  }
}
</script>

<style lang="scss" scoped>
.link {
  &.has-hover-override:hover {
    color: v-bind('hoverOverrideValue') !important;
  }
}
</style>
